import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    colors,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Theme
} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import useRouter from 'use-react-router';
import {PaginatiorInfo} from '../../../graphql/common.datatypes';
import {Resource} from '../../../graphql/resources.datatypes';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: 'relative',
    },
    content: {
        padding: 0
    },
    inner: {
      [theme.breakpoints.up('md')]: {
        minWidth: 700,
      },
        maxWidth: '90vw'
    },
    nameCell: {
        display: 'flex',
        alignItems: 'center'
    },
    avatar: {
        height: 42,
        width: 42,
        marginRight: theme.spacing(1)
    },
    actions: {
        padding: theme.spacing(1),
        justifyContent: 'flex-end'
    },
    unbalancedPayment: {
        backgroundColor: colors.orange[100],
    },
    refundPayment: {
        backgroundColor: colors.lightGreen[100],
    },
}));

const Results = (props: {
    className?: string,
    resources: Resource[],
    paginatorInfo?: PaginatiorInfo,
    setPage?: (page: number) => void,
    rowsPerPage?: number,
    setRowsPerPage?: (rowsPerPage: number) => void,
    onRowClick: (resourceId: number) => void,
}) => {
    const {className, rowsPerPage, setPage, setRowsPerPage, paginatorInfo, resources, onRowClick, ...rest} = props;
    const classes = useStyles();
    const {history} = useRouter();

    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
        if (setPage) setPage(page + 1);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        if (setRowsPerPage) setRowsPerPage(Number(event.target.value));
    };

    return (
        <div
            {...rest}
            className={clsx(classes.root, className)}
        >
            <Card>
                <CardHeader title={'Resources'}/>
                <Divider/>
                <CardContent className={classes.content}>
                    <PerfectScrollbar>
                        <div className={classes.inner}>
                            <Table style={{width: '100%'}}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Internal Name</TableCell>
                                        <TableCell>Display Name</TableCell>
                                        <TableCell style={{width: 100}}>Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {resources.map(resource => {

                                        return (
                                            <TableRow hover key={resource.id}>
                                                <TableCell>{resource.internal_name}</TableCell>
                                                <TableCell>{resource.display_name}</TableCell>
                                                <TableCell>
                                                    <Button color="primary" variant="outlined" onClick={() => onRowClick(resource.id)}>
                                                        Set Parent
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </div>
                    </PerfectScrollbar>
                </CardContent>
                {paginatorInfo && rowsPerPage && (
                    <CardActions className={classes.actions}>
                        <TablePagination
                            component="div"
                            count={paginatorInfo.total}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                            page={paginatorInfo.currentPage - 1}
                            rowsPerPage={rowsPerPage}
                            rowsPerPageOptions={[25, 50, 100]}
                        />
                    </CardActions>
                )}
            </Card>
        </div>
    );
};

export default Results;
